import React from 'react';
import { storesContext } from '../contexts';

export const useWebStores = () => React.useContext(storesContext);
